import request from '@/plugin/axios';

// 1	俱乐部公开赛-成绩录入
// 1.1	主查询列表
export function clubManage (params) {
  return request({
    url: request.adornUrl(
      `/ctCompetition/grade/grading-match/achievement/club/manage/${
        params.ctId
      }/${params.firstGroup}/${params.round}`
    ),
    method: 'get'
  });
}

// 1.2	修改俱乐部成绩接口
export function achievementInfoWhole (data) {
  return request({
    url: request.adornUrl(
      `/ctCompetition/grade/achievement-manage/club/achievement-info/whole/${
        data.againstId
      }`
    ),
    method: 'put',
    data
  });
}

// 俱乐部弃权接口
export function abstentionResults (againstId,signNum,doubleSort,params={weatherReferee:true}) {
  return request({
    url: request.adornUrl(`/ctCompetition/grade/abandonClubDoubleScore/${againstId}/${signNum}/${doubleSort}`),
    method: 'get',
    params
  });
}

// 1.3	修改1队或2队名单
export function saveAttendanceList (data) {
  return request({
    url: request.adornUrl('/cbClub/saveAttendanceList'),
    method: 'post',
    data
  });
}

// 1.4	查询俱乐部赛报名的会员名单（过滤掉已填写的会员）
export function getEnrollClubMemberList2 (params) {
  return request({
    url: request.adornUrl('/mbMember/getEnrollClubMemberList2'),
    method: 'get',
    params
  });
}

// 1.5	查询俱乐部赛出场会员名单
export function getClubDoubleSortMemberList (params) {
  return request({
    url: request.adornUrl('/mbMember/getClubDoubleSortMemberList'),
    method: 'get',
    params
  });
}

// 2	俱乐部公开赛-设置领队
// 2.0	设置领队
export function setTeamLeader (params) {
  return request({
    url: request.adornUrl('/elEnrollOrder/setTeamLeader'),
    method: 'get',
    params
  });
}

// 2.1	领队列表查询接口
export function getEnrollClubMemberTeamLeaderList (params) {
  return request({
    url: request.adornUrl('/mbMember/getEnrollClubMemberTeamLeaderList'),
    method: 'get',
    params
  });
}

// 2.2	报名会员列表查询接口
export function getEnrollClubMemberListByParam (params) {
  return request({
    url: request.adornUrl('/mbMember/getEnrollClubMemberListByParam'),
    method: 'get',
    params
  });
}
